/* Progressive enhancement: source copy stays in server HTML and native details.
   Only the collection information section is touched; never products or menus. */
(() => {
  'use strict';
  const moreLabel = /^(Mehr lesen|Read more|Weniger lesen|Read less)$/i;
  const faqLabel = /^(FAQ\b|FAQs\b|Häufig(?:e| gestellte) Fragen\b|Haeufig(?:e| gestellte) Fragen\b|Frequently asked questions\b|Q\s*&\s*A\b)/i;
  function enhance(root) {
    if (!root || root.dataset.nmGuideEnhanced) return;
    root.dataset.nmGuideEnhanced = '1';
    const content = root.querySelector('.nm-collection-faq-bottom__content');
    if (!content || content.querySelector('[data-nm-curated-guide]')) return;
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const reading = [...content.querySelectorAll('details')].filter(d => {
      const s = d.querySelector(':scope > summary');
      return d.classList.contains('nm-collection-readmore') || (s && moreLabel.test(s.textContent.trim()));
    });
    reading.forEach(d => {
      d.classList.add('nm-collection-readmore');
      const s = d.querySelector(':scope > summary');
      if (s && !s.querySelector('.nm-collection-readmore__more')) {
        const more = document.createElement('span'); more.className = 'nm-collection-readmore__more'; more.textContent = english ? 'Read more' : 'Mehr lesen';
        const less = document.createElement('span'); less.className = 'nm-collection-readmore__less'; less.textContent = english ? 'Read less' : 'Weniger lesen';
        s.replaceChildren(more, less);
      }
    });
    // Existing nested reading controls caused two consecutive "Mehr lesen" clicks.
    reading.forEach(d => {
      if (!d.parentElement.closest('details.nm-collection-readmore')) return;
      d.querySelector(':scope > summary')?.remove();
      d.replaceWith(...d.childNodes);
    });
    const group = document.createElement('section');
    group.className = 'nm-collection-questions';
    group.setAttribute('aria-label', english ? 'Frequently asked questions' : 'Häufige Fragen');
    const groupHeading = document.createElement('h2');
    groupHeading.textContent = english ? 'Frequently asked questions' : 'Häufige Fragen';
    group.append(groupHeading);
    const moved = new Set();
    function addQuestion(heading, nodes) {
      if (!nodes.some(n => n.textContent.trim())) return false;
      const d = document.createElement('details'); d.className = 'nm-collection-question';
      const s = document.createElement('summary'); s.textContent = heading.textContent.trim();
      const answer = document.createElement('div'); answer.className = 'nm-collection-question__answer';
      nodes.forEach(n => answer.append(n)); d.append(s, answer); group.append(d);
      moved.add(heading); heading.remove(); return true;
    }
    // h3 questions followed by paragraphs/lists. A new h1/h2/h3 ends an answer.
    [...content.querySelectorAll('h3')].forEach(h => {
      if (h.closest('details.nm-collection-question') || !/[?？]\s*$/.test(h.textContent)) return;
      const nodes = []; let n = h.nextSibling;
      while (n && !(n.nodeType === 1 && /^H[123]$/.test(n.tagName))) { nodes.push(n); n = n.nextSibling; }
      addQuestion(h, nodes);
    });
    // Some older FAQ answers use one paragraph: <strong>Question?</strong><br>Answer.
    [...content.querySelectorAll('h2,h3')].filter(h => faqLabel.test(h.textContent.trim())).forEach(h => {
      let n = h.nextElementSibling;
      while (n && !/^H[12]$/.test(n.tagName)) {
        const next = n.nextElementSibling;
        const strong = n.tagName === 'P' ? n.querySelector(':scope > strong:first-child') : null;
        if (strong && /[?？]\s*$/.test(strong.textContent) && n.textContent.length > strong.textContent.length + 3) {
          const heading = document.createElement('h3'); heading.textContent = strong.textContent;
          strong.remove(); n.querySelector(':scope > br:first-child')?.remove();
          addQuestion(heading, [n]);
        }
        n = next;
      }
      // Hide only an empty FAQ heading; never delete unparsed answers.
      let next = h.nextElementSibling;
      if (!next || /^H[12]$/.test(next.tagName) || next.tagName === 'SCRIPT') h.remove();
    });
    if (group.children.length > 1) content.append(group);
  }
  function init(scope = document) { scope.querySelectorAll('#nm-collection-faq-bottom').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
